import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=12b323c9&scoped=true"
import script from "./RegisterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&id=12b323c9&prod&scoped=true&lang=scss"
import style1 from "./RegisterComponent.vue?vue&type=style&index=1&id=12b323c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b323c9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxChipMembershipRole: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/chip/MembershipRole.vue').default,Term: require('/home/runner/work/assessment-service/assessment-service/frontend/components/Term.vue').default})
